/** @format */

/** Модель отрасли */
export class Industry {
  id!: number;
  name!: string;
}
